<template>
    <star-rating
        v-model="localRating"
        :value="value"
        :increment="1"
        :border-width="5"
        :rounded-corners="true"
        :star-size="30"
        :padding="15"
        :show-rating="false"
        inactive-color="#FFF"
        active-color="#4766FF"
        border-color="#4766FF"
    />
</template>

<script>
    import StarRating from 'vue-star-rating'

    export default {
        name: 'totem-star-rating',
        components: {
            StarRating
        },
        props: {
            value: Number
        },
        data () {
            return {
                localRating: 0
            }
        },
        watch: {
            localRating () {
                this.$emit('setRating', this.localRating)
            },
            value () {
                this.localRating = this.value
            }
        },
        mounted () {
            this.localRating = this.value
        }
    }
</script>
